<template>
  <div class="about-us-wrapper">
    <!-- Hero Section -->
    <section class="hero-section">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="11" lg="11">
            <div class="hero-content">
              <h1 class="hero-title">Oh Yes Home Solutions</h1>
              <p class="hero-subtitle">
                Transforming houses into intelligent homes with AI-powered innovation
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Main Content Section -->
    <section class="content-section">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="11" lg="11">
            <!-- Feature Cards -->
            <v-row class="mb-10">
              <v-col cols="12" md="6">
                <div class="feature-card">
                  <div class="feature-icon">
                    <v-icon color="#f46523" size="40">mdi-rocket-launch</v-icon>
                  </div>
                  <h3 class="feature-title">Innovation First</h3>
                  <p class="feature-text">
                    We're revolutionizing home solutions with cutting-edge AI technology, providing
                    comprehensive services from construction to automation.
                  </p>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <div class="feature-card">
                  <div class="feature-icon">
                    <v-icon color="#f46523" size="40">mdi-brain</v-icon>
                  </div>
                  <h3 class="feature-title">AI-Powered Excellence</h3>
                  <p class="feature-text">
                    Our AI systems deliver real-time responses, personalized recommendations, and
                    creative solutions tailored to your unique needs.
                  </p>
                </div>
              </v-col>
            </v-row>

            <!-- Why Choose Us -->
            <div class="content-card">
              <h2 class="section-heading">
                <v-icon color="#f46523" size="28" class="mr-2">mdi-star-circle</v-icon>
                Why Choose Us
              </h2>
              <div class="text-content">
                <p>
                  At Oh Yes Home Solutions, we are passionate about using technology to improve the
                  quality of our services. By incorporating artificial intelligence into every
                  aspect of our work, we provide more accurate and efficient solutions.
                </p>
                <p>
                  Our AI-powered systems enable exceptional customer care with real-time responses
                  and personalized recommendations. This helps us build stronger relationships and
                  ensure complete satisfaction.
                </p>
                <p>
                  With advanced algorithms, we create fresh and unique solutions tailored to each
                  client's requirements. Our online and mobile application makes it easy to make
                  requests and track progress, earning us a reputation as industry leaders.
                </p>
              </div>

              <div class="cta-box">
                <div class="cta-content">
                  <h3 class="cta-title">Ready to Transform Your Home?</h3>
                  <p class="cta-text">
                    Join us on our journey to revolutionize the home solutions industry.
                  </p>
                </div>
              </div>
            </div>

            <!-- Vision & Mission -->
            <v-row class="vm-section">
              <v-col cols="12" md="6">
                <div class="vm-card">
                  <div class="vm-icon">
                    <v-icon color="#f46523" size="44">mdi-eye-outline</v-icon>
                  </div>
                  <h2 class="vm-title">Vision</h2>
                  <p class="vm-text">
                    OH Yes is a digital platform connecting 10 Million customers across India with
                    verified service providers. We're your personal concierge and assistant,
                    integrating all your home devices through simple Wi-Fi connectivity.
                  </p>
                  <p class="vm-text">
                    Achieved through IoT integration with our app - the technology of tomorrow.
                  </p>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <div class="vm-card">
                  <div class="vm-icon">
                    <v-icon color="#f46523" size="44">mdi-target</v-icon>
                  </div>
                  <h2 class="vm-title">Mission</h2>
                  <p class="vm-text">
                    Mobile devices and internet have transformed how we work. Today, seamless global
                    coordination happens with just one text message. We're bringing this same
                    efficiency to home services.
                  </p>
                  <p class="vm-text">
                    Our platform makes professional home services as accessible as sending a
                    message.
                  </p>
                </div>
              </v-col>
            </v-row>

            <!-- Info Cards -->
            <v-row class="info-section">
              <v-col cols="12" md="4">
                <div class="info-card">
                  <div class="info-icon">
                    <v-icon color="#f46523" size="36">mdi-bullseye-arrow</v-icon>
                  </div>
                  <h3 class="info-title">Our Aim</h3>
                  <p class="info-text">
                    Providing direct employment to around 0.1 million people and indirect earnings
                    opportunities to 15,000 people through our business model.
                  </p>
                </div>
              </v-col>

              <v-col cols="12" md="4">
                <div class="info-card">
                  <div class="info-icon">
                    <v-icon color="#f46523" size="36">mdi-account-tie</v-icon>
                  </div>
                  <h3 class="info-title">Service Provider</h3>
                  <p class="info-text">
                    Any individual or firm offering their skills or products to resolve problems at
                    your doorstep. We ensure services are done properly and mutually beneficial.
                  </p>
                </div>
              </v-col>

              <v-col cols="12" md="4">
                <div class="info-card">
                  <div class="info-icon">
                    <v-icon color="#f46523" size="36">mdi-account-heart</v-icon>
                  </div>
                  <h3 class="info-title">Customer</h3>
                  <p class="info-text">
                    Anyone with requirements to fulfill - from appliance maintenance to fitness
                    trainers. Choose from our hub and get it done in a few clicks.
                  </p>
                </div>
              </v-col>
            </v-row>

            <!-- Team Section -->
            <div class="team-section">
              <div class="section-header">
                <h2 class="section-title">Meet Our Leadership</h2>
                <p class="section-subtitle">Visionaries driving innovation in home solutions</p>
              </div>

              <v-row>
                <v-col cols="12" md="6">
                  <div class="team-card">
                    <div class="team-header">
                      <div class="team-avatar">
                        <v-icon size="56" color="#f46523">mdi-account-circle</v-icon>
                      </div>
                      <div>
                        <h3 class="team-name">Tinju Padmanabhan</h3>
                        <div class="team-role">
                          <v-icon small color="#f46523" class="mr-1">mdi-crown</v-icon>
                          CEO & Founder
                        </div>
                      </div>
                    </div>
                    <p class="team-bio">
                      With years of experience in marketing and planning, including work with RMCL
                      NSE and BSE listed company (2016-2019), and founding Indlon Farms and
                      Developers Lanka Pvt Ltd (2011-2015). Career began with a car detailing
                      center, then financial broker and franchise owner with Kotak Securities
                      (2009-2017).
                    </p>
                  </div>
                </v-col>

                <v-col cols="12" md="6">
                  <div class="team-card">
                    <div class="team-header">
                      <div class="team-avatar">
                        <v-icon size="56" color="#f46523">mdi-account-circle</v-icon>
                      </div>
                      <div>
                        <h3 class="team-name">Milan Mathew</h3>
                        <div class="team-role">
                          <v-icon small color="#f46523" class="mr-1">mdi-shield-star</v-icon>
                          COO & Co-founder
                        </div>
                      </div>
                    </div>
                    <p class="team-bio">
                      Strategic and results-driven operations and technology leader with over 22
                      years of global experience across Fortune 50 organizations and high-growth
                      initiatives. Proven expertise in building scalable platforms, driving business
                      transformation, and leveraging AI-driven automation to improve efficiency,
                      decision-making, and customer experience.
                    </p>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {
      mobile: '',
    };
  },
  methods: {
    sendLink() {
      if (this.mobile) {
        alert(`Download link sent to ${this.mobile}`);
        this.mobile = '';
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap');

* {
  box-sizing: border-box;
}

.about-us-wrapper {
  font-family: 'Nunito Sans', sans-serif;
  background: #ffffff;
  min-height: 100vh;
}

/* Hero Section */
.hero-section {
  padding: 120px 20px 20px;
  margin-top: 40px;
  text-align: center;
}

.hero-content {
  animation: fadeInUp 0.8s ease-out;
}

.hero-title {
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-weight: 800;
  color: #f46523;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: clamp(1.1rem, 2vw, 1.3rem);
  color: #666;
  font-weight: 400;
  max-width: 650px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Content Section */
.content-section {
  padding: 0px 20px 10px;
}

/* Feature Cards */
.feature-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 36px 28px;
  text-align: center;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  height: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.feature-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(244, 101, 35, 0.12);
  border-color: #f46523;
}

.feature-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff5f0;
  border-radius: 50%;
}

.feature-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
}

.feature-text {
  font-size: 1rem;
  color: #666;
  line-height: 1.7;
  margin: 0;
}

/* Content Card */
.content-card {
  background: #fafafa;
  border-radius: 20px;
  padding: 40px 36px;
  margin: 50px 0;
  border: 1px solid #f0f0f0;
}

.section-heading {
  font-size: 2rem;
  font-weight: 800;
  color: #333;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
}

.text-content p {
  font-size: 1.05rem;
  color: #555;
  line-height: 1.8;
  margin-bottom: 16px;
}

.text-content p:last-child {
  margin-bottom: 0;
}

/* CTA Box */
.cta-box {
  margin-top: 32px;
  padding: 28px;
  background: #fff5f0;
  border-radius: 16px;
  border: 1px solid #ffe5d9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.cta-content {
  flex: 1;
  min-width: 250px;
}

.cta-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 6px;
}

.cta-text {
  font-size: 1rem;
  color: #666;
  margin: 0;
}

.cta-button {
  border-radius: 50px !important;
  padding: 24px 32px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  transition: all 0.3s ease !important;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(244, 101, 35, 0.3) !important;
}

/* Vision Mission Section */
.vm-section {
  margin: 50px 0;
}

.vm-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 36px 30px;
  border: 1px solid #f0f0f0;
  height: 100%;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.vm-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(244, 101, 35, 0.1);
}

.vm-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff5f0;
  border-radius: 50%;
}

.vm-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
  text-align: center;
}

.vm-text {
  font-size: 1rem;
  color: #666;
  line-height: 1.7;
  margin-bottom: 12px;
}

.vm-badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background: #f46523;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #fff;
  margin-top: 12px;
}

/* Info Cards */
.info-section {
  margin: 50px 0;
}

.info-card {
  background: #fafafa;
  border-radius: 16px;
  padding: 32px 24px;
  text-align: center;
  height: 100%;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(244, 101, 35, 0.1);
  border-color: #f46523;
}

.info-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff5f0;
  border-radius: 50%;
}

.info-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
}

.info-text {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.7;
}

/* Team Section */
.team-section {
  margin: 60px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-title {
  font-size: 2.25rem;
  font-weight: 800;
  color: #333;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #666;
  font-weight: 400;
}

.team-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 28px;
  border: 1px solid #f0f0f0;
  height: 100%;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.team-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(244, 101, 35, 0.12);
}

.team-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.team-avatar {
  flex-shrink: 0;
  width: 70px;
  height: 70px;
  background: #fff5f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.team-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 4px;
}

.team-role {
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  color: #f46523;
  font-weight: 600;
}

.team-bio {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.7;
  margin-bottom: 20px;
}

.team-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.badge {
  padding: 6px 14px;
  background: #fff5f0;
  border: 1px solid #ffe5d9;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #f46523;
}

/* App Download */
.app-download {
  margin: 60px 0 40px;
  padding: 40px 36px;
  background: linear-gradient(135deg, #f46523 0%, #ff9800 100%);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 8px 30px rgba(244, 101, 35, 0.25);
}

.app-icon {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.app-content {
  margin-bottom: 28px;
}

.app-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: #fff;
  margin-bottom: 6px;
}

.app-subtitle {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.95);
  margin: 0;
}

.app-form {
  display: flex;
  gap: 12px;
  width: 100%;
  max-width: 480px;
}

.mobile-input {
  flex: 1;
  background: #fff;
  border-radius: 8px;
}

.send-btn {
  border-radius: 8px !important;
  padding: 0 28px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  background: #fff !important;
  color: #f46523 !important;
  letter-spacing: 0 !important;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 960px) {
  .hero-section {
    padding: 80px 16px 10px;
  }

  .content-section {
    padding: 10px 16px 60px;
  }

  .section-heading {
    font-size: 1.75rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .cta-box {
    flex-direction: column;
    text-align: center;
  }

  .team-header {
    flex-direction: column;
    text-align: center;
  }

  .app-form {
    flex-direction: column;
  }

  .send-btn {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .hero-section {
    padding: 60px 16px 0px;
  }

  .content-card,
  .app-download {
    padding: 28px 24px;
  }

  .feature-card,
  .vm-card,
  .info-card,
  .team-card {
    padding: 28px 20px;
  }
}
</style>
